import SelectDropdown from 'react-native-select-dropdown'
import { Div, Label } from '../../basic';
import { SelectProps } from './Select.types';
import { useTheme } from '@grassrootly/rn-core/src/structure';
import { View, Image } from 'react-native';
import { Loader } from '../../basic/loader';

const Select = (props: SelectProps) => {
  const { theme } = useTheme();
  const preselectedItem = props.selectedOption ? props.options.find((o) => o.value === props.selectedOption) : null;

  return (
    <SelectDropdown
      data={props.options}
      onSelect={(selectedItem, index) => {
        if (props.onSelect) {
          props.onSelect(selectedItem, index);
        }
      }}
      renderButton={(selectedItem, isOpened) => {
        const labelText = (!props.selectedOption || !props.forceSelectedOption)
          ? ((selectedItem && selectedItem.label) || (preselectedItem && preselectedItem.label) || props.placeholderText || 'Please select...')
          : ((preselectedItem && preselectedItem.label) || props.placeholderText || 'Please select...');
        
        const iconSource = (!props.selectedOption || !props.forceSelectedOption)
          ? ((selectedItem && selectedItem.icon) || (preselectedItem && preselectedItem.icon))
          : (preselectedItem && preselectedItem.icon);

        return (
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              minWidth: 200,
              borderWidth: 1,
              borderColor: theme.colors.primary.dark,
              borderRadius: 8,
              paddingHorizontal: 12,
              paddingVertical: 8,
              backgroundColor: theme.colors.primary.main + '20',
            }}
          >
            {!props.isLoading && (
              <View style={{ flexDirection: 'row', alignItems: 'center', flex: 1 }}>
                {iconSource && (
                  <Image
                    source={{ uri: iconSource }}
                    style={{
                      width: 20,
                      height: 20,
                      borderRadius: 10,
                      marginRight: 8,
                    }}
                    resizeMode="cover"
                  />
                )}
                <Label classNames={["flex1"]}>
                  {labelText}
                </Label>
              </View>
            )}
            {props.isLoading && (
              <Loader isLoading={props.isLoading} size={20} color={'#fff'} />
            )}
            {!props.isLoading && (
              <Label classNames={["ml-{8}"]}>{isOpened ? '▴' : '▾'}</Label>
            )}
          </View>
        );
      }}
      renderItem={(item, index, isSelected) => {
        return (
          <View style={{ 
            paddingLeft: 10, 
            paddingRight: 10, 
            paddingTop: 5, 
            paddingBottom: 5, 
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {item.icon && (
              <Image
                source={{ uri: item.icon }}
                style={{
                  width: 20,
                  height: 20,
                  borderRadius: 10,
                  marginRight: 8,
                }}
                resizeMode="cover"
              />
            )}
            <Label color={theme.colors.info.light}>{item.label}</Label>
          </View>
        );
      }}
      showsVerticalScrollIndicator={false}
      dropdownStyle={{
        backgroundColor: theme.colors.primary.dark,
        borderRadius: 8,
        minWidth: 200,
        paddingTop: 10,
        paddingBottom: 10,
      }}
    />);
}
export default Select;